import { hasChecklistWarning } from "../BankruptcyChecklist.utils";
import { useBankruptcyChecklist } from "./useBankruptcyChecklist";

export function useBankruptcyChecklistHasWarning(clientId: string | undefined): boolean {
  const { data } = useBankruptcyChecklist(clientId);
  return hasChecklistWarning(data);
}
